import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import BotonSalirLimiarStorageCatalogo from "./BotonSalirLimpiarStorageCatalogo";
import FormImformacionColaborador from "../components/FormInformacionColaborador";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const DetalleInformacionColaborador = ({
  idColaborador,
  colaborador,
  identificacion,
}) => {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

//   const [idLocalInformacion, setIdLocalInformacion] = useState(idLocal);

  useEffect(() => {
    console.log({ idColaborador });
    console.log({ colaborador });
    console.log({ identificacion });
  }, []);

  return (
    <>
      <BotonSalirLimiarStorageCatalogo />
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{ borderBottom: 1, borderColor: "divider" }}
          className="cabecera-tabs-clientes"
        >
          
          {/*<Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            textColor="inherit"
            variant="fullWidth"
            >
             <Tab label="Información Colaborador" {...a11yProps(0)} /> 
            
          </Tabs>*/}
        </Box>
        <TabPanel value={value} index={0}>
          <FormImformacionColaborador
            idColaborador={idColaborador}
            colaborador={colaborador}
          />
        </TabPanel>
      </Box>
    </>
  );
};

export default DetalleInformacionColaborador;
